export default {
    title: 'Email Notifications',
    save_template: 'Save Template',
    send: 'Send',
    select_email_template: 'Select Email Template',
    template_type: 'Template type',
    email_to_test: 'Email to Test',
    subject: 'Subject',
}